import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { ArrowLeft } from 'react-feather';

import { Box, Container } from '@material-ui/core';
import { useParams, useNavigate } from 'react-router-dom';
import NotificationPageKoala from 'components/NotificactionPages/NotificationPagesKoala';
import { BaseUrl } from '../utils/factory';

const axios = require('axios');

const NotificationKoalaPage = () => {
  const navigate = useNavigate();
  const [loaderstate, setLoaderstate] = useState(false);

  const { id } = useParams();
  // console.log('Props::::::::::::::::::::::', id);
  const [invoicelist, setInvoicelList] = useState([]);

  const loadNoteData = async () => {
    const tranuserid = localStorage.getItem('tranuserid');
    try {
      setLoaderstate(true);
      axios
        .post(`${BaseUrl}tranlog`, {
          clientid: tranuserid,
          snoid: id,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          // console.log('hello::::::::::::::', response.data.d);
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = JSON.parse(response.data.d);
            //  console.log('hello////////////////////', userdata);
            setInvoicelList(userdata);
          } else setInvoicelList([]);
          setLoaderstate(false);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
      setLoaderstate(false);
    }
  };

  useEffect(() => {
    loadNoteData();
  }, []);

  const handleBack = () => {
    navigate('/app/products', { replace: true });
  };
  return (
    <>
      <Helmet>
        <title>Notification List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            <ArrowLeft onClick={handleBack} />

            <NotificationPageKoala
              product={invoicelist}
              loaderstate={loaderstate}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default NotificationKoalaPage;
